export default __webpack_public_path__ + "9f1407d5bb0df40f10d05f9ce531dfbc.png";